document.addEventListener('DOMContentLoaded', function() {
  WebpIsSupported(function(isSupported){
      if(!isSupported){
        var elements = document.getElementsByClassName('js_webp');

        for (var i = 0; i < elements.length; i++) {
          elements[i].classList.add('no-webp');
        }
      }
  });
});

function WebpIsSupported(callback){
  if(!window.createImageBitmap){
      callback(false);
      return;
  }

  var webpdata = 'data:image/webp;base64,UklGRiQAAABXRUJQVlA4IBgAAAAwAQCdASoCAAEAAQAcJaQAA3AA/v3AgAA=';

  fetch(webpdata).then(function(response){
      return response.blob();
  }).then(function(blob){
      createImageBitmap(blob).then(function(){
          callback(true);
      }, function(){
          callback(false);
      });
  });
}
